<template>
  <div>
    <div class="music-card">
      <div class="music-card-inner" @click="dialog2 = true">
        <div class="border-bottom">
          <div class="d-flex">
            <div class="music-info">
              <h3>{{ music.title }}</h3>
              <time style="font-size: 11px; font-weight: bold"
                >Deadline:<span class="ml-2">{{ music.deadline }}</span></time
              >
              <br />
              <time style="font-size: 11px; font-weight: bold"
                >Added At:<span class="ml-2">{{
                  moment(music.added_at.toDate()).format("YYYY-MM-DD")
                }}</span></time
              >
              <p>{{ music.description }}</p>
            </div>
            <v-avatar v-if="music.profile_image" class="ml-auto" size="42"
              ><img :src="music.profile_image"
            /></v-avatar>
            <v-avatar v-else class="ml-auto" size="42"
              ><img src="/images/default-profile.jpg"
            /></v-avatar>
          </div>
        </div>
        <div class="d-flex align-center">
          <small
            v-if="music.paid"
            class="px-4 mt-3 d-inline-block success rounded-pill"
            >Paid</small
          >
          <small
            v-else
            class="px-4 mt-3 d-inline-block primary white--text rounded-pill"
            >Unpaid</small
          >
        </div>
      </div>

      <div class="ml-auto btn-absolute">
        <v-btn small class="mt-3" color="primary" @click="lc_apply"
          >Apply</v-btn
        >
      </div>
    </div>
    <v-dialog v-model="dialog" width="500">
      <v-card>
        <v-card-title class="text-h6 grey lighten-2">
          Apply to this gig
        </v-card-title>
        <div class="pa-4">
          <v-textarea
            placeholder="Tell us how you are perfect fit for job"
            outlined
            flat
            dense
            hide-details
          />
          <div class="d-flex mt-3">
            <v-btn
              class="ml-auto mr-3"
              color="red white--text"
              @click="dialog = false"
              >Cancel</v-btn
            >
            <v-btn color="primary" @click="dialog = false">Apply</v-btn>
          </div>
        </div>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialog2" width="500">
      <v-card>
        <v-card-title class="text-h6 grey lighten-2"> Detail </v-card-title>
        <div class="pa-4">
          <h3 class="mt-3">{{ music.title }}</h3>
          <time style="font-size: 12px; font-weight: bold"
            >Deadline: {{ music.deadline }}</time
          ><br />
          <time style="font-size: 12px; font-weight: bold"
            >Added At:
            {{ moment(music.added_at.toDate()).format("YYYY-MM-DD") }}</time
          >
          <hr />
          <p>{{ music.description }}</p>
          <br />
          <small
            v-if="music.paid"
            class="d-inline-block px-4 mt-3 d-inline-block success rounded-pill"
            >Paid</small
          >
          <small
            v-else
            class="
              d-inline-block
              px-4
              mt-3
              d-inline-block
              primary
              white--text
              rounded-pill
            "
            >Unpaid</small
          >
          <div class="d-flex mt-3">
            <v-btn
              class="ml-auto mr-3"
              color="red white--text"
              @click="dialog2 = false"
              >Close</v-btn
            >
          </div>
        </div>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import moment from "moment";
export default {
  name: "MusicCard",
  props: ["paid", "music"],
  methods: {
    moment,
  },
  data() {
    return {
      dialog: false,
      dialog2: false,
    };
  },
  methods: {
    moment
  },
};
</script>

<style scoped>
.music-card {
  cursor: pointer;
  position: relative;
  margin: 0 15px;
  border-radius: 5px;
  margin-top: 15px;
  border: 1px solid rgba(0, 0, 0, 0.2);
  padding: 15px;
}
.btn-absolute {
  position: absolute;
  right: 15px;
  bottom: 10px;
}
.success {
  background: chartreuse !important;
  color: #fff;
}
.danger1 {
  background: red !important;
  color: #fff;
}
</style>